export const parseQueryString = (url: string): { [key: string]: any } => {
  url = url.replace('?', '')

  const pairArr = url.split('&')
  const result = {}

  pairArr.forEach(pair => {
    const keyValArr = pair.split('=')
    const [key, value] = keyValArr
    Object.assign(result, {
      [key]: Object.keys(value).length ? JSON.parse(decodeURI(value)) : decodeURI(value),
    })
  })

  return result
}

export const queryStringify = (params: { [key: string]: string }) =>
  Object.keys(params)
    .map(key => `${key}=${params[key]}`)
    .join('&')
